import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient } from './http-client.service';

import  { Observable } from 'rxjs/Observable';

import { Language } from '../../entities/language';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class LanguageService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly languageBaseUrl:string = `${Settings.apiUrl}/v1/Languages`;

  public languages:Language[] = null;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getLanguages(): Promise<Language[]> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(LanguageService.languageBaseUrl);

    oDataBuilder
      .orderBy("SortOrder");

    let languageUrl: string = oDataBuilder.toString();

    return this.http.get(languageUrl)
      .toPromise()
      .then(response => {
        this.languages = response.json().value;
        return this.languages;
      });
  }

  createLanguage(resource: Language): Promise<Language> {
    let languageUrl: string = `${Settings.apiUrl}/v1/Languages`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete resource.LanguageId;

    return this.http.post(languageUrl, JSON.stringify(resource), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchLanguage(language: Language): Promise<null> {

    let languageUrl: string = `${Settings.apiUrl}/v1/Languages(${language.LanguageId})`;

    return this.http.patch(languageUrl, JSON.stringify(language), this.options)
      .toPromise()
      .then(response => response);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/language.service.ts